/* Viola Canada theme JS — drawer, quantity, variant picker, gallery */
(function () {
  'use strict';

  /* ----- mobile drawer ----- */
  var burger = document.querySelector('[data-drawer-open]');
  var drawer = document.querySelector('[data-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger && drawer) {
    burger.addEventListener('click', function () { setDrawer(true); });
    overlay.addEventListener('click', function () { setDrawer(false); });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { setDrawer(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });
  }

  /* ----- header country selector: close on outside click / Escape ----- */
  var countrySelect = document.querySelector('.country-select--header[data-country-select]');
  if (countrySelect) {
    document.addEventListener('click', function (e) {
      if (countrySelect.open && !countrySelect.contains(e.target)) countrySelect.open = false;
    });
    countrySelect.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        countrySelect.open = false;
        var toggle = countrySelect.querySelector('summary');
        if (toggle) toggle.focus();
      }
    });
  }

  /* ----- quantity steppers ----- */
  document.querySelectorAll('.qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v + (btn.dataset.step === 'up' ? 1 : -1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ----- product variant picker ----- */
  var pdpForm = document.querySelector('[data-product-form]');
  if (pdpForm) {
    var variants = JSON.parse(document.querySelector('[data-variants-json]').textContent);
    var moneyFormat = pdpForm.dataset.moneyFormat || '${{amount}}';
    var groups = Array.prototype.slice.call(pdpForm.querySelectorAll('[data-option-group]'));
    var idInput = pdpForm.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var addBtn = pdpForm.querySelector('[data-add-to-cart]');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    function selectedValues() {
      return groups.map(function (g) {
        var sel = g.querySelector('.opt-pill.is-selected');
        return sel ? sel.dataset.optionValue : null;
      });
    }
    function variantFor(values) {
      return variants.find(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      });
    }
    /* strike through any option whose combo with the other current picks has
       no available variant — mirrors the sold-out size on the mockups */
    function markAvailability() {
      var picked = selectedValues();
      groups.forEach(function (g, gi) {
        g.querySelectorAll('.opt-pill').forEach(function (pill) {
          var trial = picked.slice();
          trial[gi] = pill.dataset.optionValue;
          var v = variantFor(trial);
          pill.classList.toggle('is-unavailable', !(v && v.available));
        });
      });
    }
    function onChange() {
      markAvailability();
      var v = variantFor(selectedValues());
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.textUnavailable;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        compareEl.style.display = v.compare_at_price > v.price ? '' : 'none';
        if (v.compare_at_price > v.price) compareEl.textContent = formatMoney(v.compare_at_price);
      }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.dataset.textAdd : addBtn.dataset.textSoldout;
      var url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var pill = e.target.closest('.opt-pill');
        if (!pill || pill.classList.contains('is-selected')) return;
        g.querySelectorAll('.opt-pill').forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-checked', 'true');
        onChange();
      });
    });
    onChange();
  }

  /* ----- PDP gallery thumbs ----- */
  var mainImg = document.querySelector('[data-pdp-image]');
  document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      mainImg.src = thumb.dataset.src;
      mainImg.srcset = '';
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ----- header scroll effects (opacity fade, overlay) ----- */
  function initHeader(header) {
    if (header.dataset.headerReady) return;
    header.dataset.headerReady = 'true';
    var wrapper = header.closest('.shopify-section') || header.parentElement;
    var top = parseFloat(header.dataset.opacityTop);
    var scrolled = parseFloat(header.dataset.opacityScrolled);
    if (isNaN(top)) top = 100;
    if (isNaN(scrolled)) scrolled = 100;
    var range = parseFloat(header.dataset.scrollRange) || 300;
    var overlay = header.hasAttribute('data-overlay');
    /* overlay + transparency only make sense over a hero; on pages that
       start with regular content the header stays static and solid */
    var heroFirst = !!document.querySelector('#main > .shopify-section:first-child .hero');
    if (!heroFirst) { overlay = false; top = 100; scrolled = 100; }
    var ticking = false;
    function setOverlay() {
      wrapper.style.marginBottom = overlay ? -header.offsetHeight + 'px' : '';
    }
    function update() {
      ticking = false;
      var p = Math.min(Math.max(window.scrollY / range, 0), 1);
      header.style.setProperty('--hdr-alpha', (top + (scrolled - top) * p) / 100);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setOverlay);
    setOverlay();
    update();
  }
  document.querySelectorAll('[data-header]').forEach(initHeader);

  /* ----- hero carousel ----- */
  function initHeroCarousel(hero) {
    if (hero.dataset.carouselReady) return;
    hero.dataset.carouselReady = 'true';
    var slides = hero.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;
    var dots = hero.querySelectorAll('.hero__dot');
    var copies = hero.querySelectorAll('.hero__copy');
    var ctas = hero.querySelectorAll('.hero__cta');
    var autoplay = hero.dataset.autoplay !== 'false';
    var interval = (parseInt(hero.dataset.interval, 10) || 5) * 1000;
    var current = 0;
    var timer = null;
    var started = false;
    function go(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      if (copies[current]) copies[current].classList.remove('is-active');
      if (ctas[current]) ctas[current].classList.remove('is-active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
      if (copies[current]) copies[current].classList.add('is-active');
      if (ctas[current]) ctas[current].classList.add('is-active');
    }
    function play() {
      if (!autoplay || timer) return;
      /* first move comes quickly so the carousel visibly starts; after that it
         settles into the configured interval */
      var delay = started ? interval : Math.min(2600, interval);
      timer = setTimeout(function tick() {
        go(current + 1);
        started = true;
        timer = setTimeout(tick, interval);
      }, delay);
    }
    function stop() { clearTimeout(timer); timer = null; }
    hero.heroGoTo = function (n) { stop(); go(n); };
    hero.heroPlay = play;
    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () { stop(); go(n); play(); });
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : play();
    });
    play();
  }
  document.querySelectorAll('[data-hero-carousel]').forEach(initHeroCarousel);

  /* ----- full-height hero: expose the header height so the hero can fill the
     rest of the screen, then fade in the section that follows on scroll ----- */
  var docEl = document.documentElement;
  function measureHeader() {
    var main = document.getElementById('main');
    if (main) docEl.style.setProperty('--header-h', main.offsetTop + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);

  var firstHero = document.querySelector('.hero');
  if (firstHero) {
    var heroWrap = firstHero.closest('.shopify-section') || firstHero.parentElement;
    var nextSection = heroWrap && heroWrap.nextElementSibling;
    if (nextSection) {
      nextSection.classList.add('reveal-on-scroll');
      if ('IntersectionObserver' in window) {
        var revealIO = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        revealIO.observe(nextSection);
      } else {
        nextSection.classList.add('is-revealed');
      }
    }
  }

  /* theme editor: re-init after settings change, jump to the slide being edited */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hero-carousel]').forEach(initHeroCarousel);
    e.target.querySelectorAll('[data-header]').forEach(initHeader);
    measureHeader();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest('[data-hero-carousel]');
    if (!hero || !hero.heroGoTo) return;
    var n = Array.prototype.indexOf.call(hero.querySelectorAll('.hero__slide'), e.target);
    if (n > -1) hero.heroGoTo(n);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hero = e.target.closest('[data-hero-carousel]');
    if (hero && hero.heroPlay) hero.heroPlay();
  });
})();
